import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clearPaneContent } from 'services/pane/slice';
import { spaLinkProps } from 'utils/spaLink';
import styles from './PaneHeader.module.css';

interface PaneHeaderProps {
  children: ReactNode;
  expandTo?: string;
  showExpandIcon?: boolean;
}

const ExpandIcon = () => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
  >
    <path d="M3 3h7v2H5v5H3V3zm11 0h7v7h-2V5h-5V3zM3 14h2v5h5v2H3v-7zm16 0h2v7h-7v-2h5v-5z" />
  </svg>
);

const PaneHeader = ({
  children,
  expandTo,
  showExpandIcon = true,
}: PaneHeaderProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const expandLink = showExpandIcon && expandTo
    ? spaLinkProps(expandTo, navigate)
    : null;

  return (
    <div className={styles.header}>
      <div className={styles.title}>
        {children}
      </div>
      {
        expandLink && (
          <a
            aria-label={t('openInFullPage')}
            className={styles.expand}
            href={expandLink.href}
            onClick={event => {
              expandLink.onClick(event);
              if (event.defaultPrevented) {
                dispatch(clearPaneContent());
              }
            }}
            title={t('openInFullPage')}
          >
            <ExpandIcon />
          </a>
        )
      }
    </div>
  );
};

export default PaneHeader;
